module.exports = __webpack_public_path__ + "static/assets/28f7d455e15b9e459aec9824ec85f346.png";